import React from 'react';

/**
 * Renderiza el bloque CurrentChart de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function CurrentChart({
  v
}) {
  return React.createElement("div", {
    className: "scapp-detail-chart-row",
    style: {
      "display": v.showDepth ? "grid" : "none",
      "gridTemplateColumns": "13.541667vw 2.291667vw minmax(0,1fr) 4.791667vw",
      "gap": "0",
      "alignItems": "center"
    }
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "justifyContent": "center",
      "paddingRight": "0.208333vw",
      "minWidth": "0"
    }
  }, React.createElement("div", {
    role: "button",
    tabIndex: 0,
    "data-detail-legend": "depth",
    "aria-pressed": v.showDepthSeries,
    onClick: () => v.toggleDetailMetric("depth"),
    onKeyDown: event => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        v.toggleDetailMetric("depth");
      }
    },
    style: {
      "display": "grid",
      "border": "0",
      "background": "transparent",
      "padding": "0",
      "width": "100%",
      "textAlign": "left",
      "cursor": "pointer",
      "opacity": v.showDepthSeries ? "1" : "0.38",
      "gridTemplateColumns": "0.625vw minmax(0,1fr) auto auto",
      "gap": "0.740741vh",
      "alignItems": "center",
      "fontSize": "1.203704vh",
      "lineHeight": "1.851852vh",
      "height": "1.851852vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "background": "oklch(0.75 0.09 190)"
    }
  }, null), React.createElement("span", {
    style: {
      "color": "#b8c1ce",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text("Prof. [m]")), React.createElement("span", {
    style: {
      "font": "600 1.296296vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.75 0.09 190)",
      "opacity": v.vOp,
      "whiteSpace": "nowrap"
    }
  }, v.text(v.vD)), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.092593vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.37037vh",
      "padding": "0.092593vh"
    }
  }, (v.dMetOpts || []).map((m, index29) => React.createElement(React.Fragment, {
    key: index29
  }, React.createElement("button", {
    "onClick": event => {
      event.stopPropagation();
      m.onClick();
    },
    "title": m.title,
    style: {
      "border": "0",
      "borderRadius": "0.277778vh",
      "padding": "0 0.555556vh",
      "height": "1.481481vh",
      "font": "0.925926vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color
    }
  }, v.text(m.label)))))), React.createElement("div", {
    style: {
      "fontSize": "1.018519vh",
      "lineHeight": "1.481481vh",
      "color": "#8793a6",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis",
      "paddingLeft": "1.041667vw"
    }
  }, React.createElement("span", {
    style: {
      "color": v.dIns.c,
      "fontWeight": "600"
    }
  }, v.text(v.dIns.lab)), v.text(" " + v.dIns.txt))), React.createElement("div", {
    "onMouseMove": v.hMove,
    "onMouseLeave": v.hLeave,
    "onMouseDown": v.hDown,
    "onMouseUp": v.hUp,
    "onWheel": v.hWheel,
    "data-wheel-zoom": "1",
    style: {
      "gridColumn": "3",
      "position": "relative",
      "display": "flex",
      "flexDirection": "column",
      "cursor": v.hCursor,
      "userSelect": "none"
    }
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": "0",
      "height": v.dH.d / 10.8 + "vh",
      "pointerEvents": "none",
      "display": v.showDepthSeries ? "block" : "none",
      "background": "rgba(4,12,24,0.55)",
      "borderRadius": "0.37037vh",
      "overflow": "hidden"
    }
  }, (v.dHeat || []).map((h, index30) => React.createElement(React.Fragment, {
    key: index30
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": h.top,
      "height": h.h,
      "background": h.bg
    }
  }, null)))), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": "0",
      "bottom": "0",
      "pointerEvents": "none"
    }
  }, (v.det.axD || []).map((t, index31) => React.createElement(React.Fragment, {
    key: index31
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": t.top,
      "borderTop": "0.092593vh solid rgba(135,147,166,0.13)"
    }
  }, null)))), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "-2.291667vw",
      "width": "2.291667vw",
      "top": "0",
      "bottom": "0",
      "pointerEvents": "none",
      "display": v.showDepthSeries ? "block" : "none",
      "borderRight": "0.052083vw solid oklch(0.75 0.09 190 / 0.55)"
    }
  }, (v.det.axD || []).map((t, index32) => React.createElement(React.Fragment, {
    key: index32
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0",
      "top": t.top,
      "width": "0.208333vw",
      "borderTop": "0.092593vh solid oklch(0.75 0.09 190)"
    }
  }, null), React.createElement("span", {
    style: {
      "position": "absolute",
      "right": "0.364583vw",
      "top": t.lt,
      "transform": "translateY(-50%)",
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "whiteSpace": "nowrap",
      "color": "oklch(0.75 0.09 190)"
    }
  }, v.text(t.lab))))), React.createElement("svg", {
    "viewBox": v.zVB,
    "preserveAspectRatio": "none",
    style: {
      "position": "relative",
      "width": "100%",
      "height": v.dH.d / 10.8 + "vh",
      "display": "block",
      "borderRadius": "0.37037vh"
    }
  }, React.createElement("path", {
    "d": v.czSpan,
    "fill": "oklch(0.66 0.19 42 / 0.16)",
    "stroke": "none"
  }, null), React.createElement("path", {
    "d": "M0 5 H600",
    "stroke": "#2a3446",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke"
  }, null), React.createElement("path", {
    "d": v.det.dep,
    "display": v.showDepthSeries ? "inline" : "none",
    "stroke": "oklch(0.75 0.09 190)",
    "strokeWidth": "2",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke"
  }, null)), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": v.hx,
      "width": "0.052083vw",
      "background": "#e4e9f0",
      "opacity": "0.55",
      "pointerEvents": "none",
      "display": v.hDisp
    }
  }, null), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": v.selL,
      "width": v.selW,
      "background": "rgba(228,233,240,0.12)",
      "borderLeft": "0.052083vw solid #8793a6",
      "borderRight": "0.052083vw solid #8793a6",
      "pointerEvents": "none",
      "display": v.selD
    }
  }, null)));
}
